module.exports = __webpack_public_path__ + "img/0795693.png";